export const CARD_IMAGE = "/images/card.svg";
export const EMOJI_IMAGE = "/images/emoji.png";
